import { BottomSheet, BottomSheetTrigger } from '@holbonkit/ui'

import {
    type SelfEmployedTransactionDetailsStatusEnumKey,
    type SelfEmployedTransactionDetailsTypeEnumKey,
    useGetSelfEmployedTransaction,
} from '@/shared/api'

import { DetailsItem } from './details-item'
import { OperationRow } from './operation-row'

// const transactionExample = (
//     type: SelfEmployedTransactionListItemTypeEnumKey,
// ): GetSelfEmployedTransactionQueryResponse => {
//     switch (type) {
//         case 'payout': {
//             return getSelfEmployedTransactionExamples.payout
//         }
//         case 'dotaion': {
//             return getSelfEmployedTransactionExamples.dotaion
//         }
//         case 'achivment': {
//             return getSelfEmployedTransactionExamples.achivment
//         }
//         case 'refund':
//         case 'compensation': {
//             // Примера compensation в OpenAPI нет, разбивки у этого типа тоже нет.
//             return getSelfEmployedTransactionExamples.refund
//         }
//         case 'order': {
//             return getSelfEmployedTransactionExamples.order
//         }
//     }
// }

export const OperationsItem = ({
    id,
    amount,
    status,
    type,
    date,
}: {
    amount: number
    date: string
    id: string
    status?: SelfEmployedTransactionDetailsStatusEnumKey
    type: SelfEmployedTransactionDetailsTypeEnumKey
}) => {
    // Реальный запрос: getSelfEmployedTransaction(id)
    const {
        data: transactionData,
        refetch,
        isFetching: isTransactionFetching,
        isError: isTransactionError,
    } = useGetSelfEmployedTransaction(id, {
        query: {
            enabled: false,
            // queryFn: () => transactionExample(type),
        },
    })

    return (
        <BottomSheet>
            <BottomSheetTrigger onClick={() => refetch()}>
                <OperationRow amount={amount} date={date} status={status} type={type} />
            </BottomSheetTrigger>
            <DetailsItem
                details={transactionData?.transaction}
                isError={isTransactionError}
                isLoading={isTransactionFetching}
            />
        </BottomSheet>
    )
}
